import React from 'react';

/**
 * Pagination Controls Component
 */
export default function PaginationControls({ currentPage, totalPages, setCurrentPage }) {
  return (
    <nav>
      <ul className="pagination pagination-sm mb-0">
        <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
          <button
            className="page-link"
            onClick={() => setCurrentPage(1)}
          >
            First
          </button>
        </li>
        <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
          <button
            className="page-link"
            onClick={() =>
              setCurrentPage((c) => Math.max(c - 1, 1))
            }
          >
            Previous
          </button>
        </li>

        {[...Array(totalPages)].map((_, i) => {
          const pageNum = i + 1;

          const closeToCurrent =
            pageNum === 1 ||
            pageNum === totalPages ||
            (pageNum >= currentPage - 1 &&
              pageNum <= currentPage + 1);

          const showEllipsis =
            pageNum === currentPage - 2 ||
            pageNum === currentPage + 2;

          if (closeToCurrent) {
            return (
              <li
                key={pageNum}
                className={`page-item ${
                  currentPage === pageNum ? 'active' : ''
                }`}
              >
                <button
                  className="page-link"
                  onClick={() => setCurrentPage(pageNum)}
                >
                  {pageNum}
                </button>
              </li>
            );
          } else if (showEllipsis) {
            return (
              <li
                key={pageNum}
                className="page-item disabled"
              >
                <button className="page-link">...</button>
              </li>
            );
          }
          return null;
        })}

        <li
          className={`page-item ${
            currentPage === totalPages ? 'disabled' : ''
          }`}
        >
          <button
            className="page-link"
            onClick={() =>
              setCurrentPage((c) =>
                Math.min(c + 1, totalPages)
              )
            }
          >
            Next
          </button>
        </li>
        <li
          className={`page-item ${
            currentPage === totalPages ? 'disabled' : ''
          }`}
        >
          <button
            className="page-link"
            onClick={() => setCurrentPage(totalPages)}
          >
            Last
          </button>
        </li>
      </ul>
    </nav>
  );
}


